import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { faqs } from "../../data/content";
import { SectionCTA } from "../SectionCTA";
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white px-4 py-16 md:py-24" data-id="element-153" data-mp="2z2p6kxocvbss">
      <div className="mx-auto max-w-3xl" data-id="element-154" data-mp="2z5beiyf5rtbj">
        <h2 className="text-center font-serif text-[30px] font-extrabold leading-tight text-navy md:text-5xl" data-id="element-155" data-mp="3ms9tfrnmqt7c">
          Frequently asked <em className="italic text-brand" data-id="element-156" data-mp="3rql3a2dxd3pk">questions</em>
        </h2>
        <ul className="mt-10 space-y-3" data-id="element-157" data-mp="3d3jelf7hraqx">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="rounded-2xl border border-navy/10 bg-canvas" data-id="element-158" data-mp="3i0i6rs7lh7mh" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-[16px] font-bold text-navy md:text-lg" data-id="element-159" data-mp="9lhsc11a1xh8">
                  {f.q}
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-160" data-mp="1vpsqv0k6dapo" />
                </button>
                <AnimatePresence initial={false} data-id="element-161" data-mp="25nyrleu8wasy">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-162" data-mp="2jfddpujg8s48">
                      <p className="px-5 pb-5 text-[16px] leading-relaxed text-ink-muted" data-id="element-163" data-mp="z0l6vwz7f9nv">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
        <SectionCTA label="Get the Playbook for $27" data-id="element-164" data-mp="1js8ks3hb77tj" />
      </div>
    </section>;
}